export const toChipValue = (emails: string[]) => emails.join(";");

export const fromChipValue = (emails: string) => emails.split(";").map(email => email.trim()).filter(Boolean);
